export const getConversationSurvey = (conversationSurveyId, successCallback) => {
  return fetch(`/api/v1/conversation_surveys/${conversationSurveyId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw response.json();
      }
      return response.json();
    })
    .then(successCallback)
    .catch((error) => {
      console.error('Error getting conversation survey:', error);
    });
};

export const updateConversationSurvey = (conversationSurveyId, params, successCallback) => {
  return fetch(`/api/v1/conversation_surveys/${conversationSurveyId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) {
        throw response.json();
      }
      return response.json();
    })
    .then((data) => {
      if (successCallback) {
        successCallback(data);
      }
    })
    .catch((error) => {
      console.error('Error updating conversation survey:', error);
      alert(
        'Oops! Something went wrong. Please try again or contact support if this persists at support@patientpartner.com.'
      );
    });
};
